/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Rate_ShapingInputs */

const en_svchip_rate_shaping = /** @type {(inputs: Svchip_Rate_ShapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate shaping`)
};

const ar_svchip_rate_shaping = /** @type {(inputs: Svchip_Rate_ShapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تشكيل المعدل`)
};

const bn_svchip_rate_shaping = /** @type {(inputs: Svchip_Rate_ShapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রেট শেপিং`)
};

const de_svchip_rate_shaping = /** @type {(inputs: Svchip_Rate_ShapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifgestaltung`)
};

const es_svchip_rate_shaping = /** @type {(inputs: Svchip_Rate_ShapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conformación de tarifas`)
};

const fr_svchip_rate_shaping = /** @type {(inputs: Svchip_Rate_ShapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise en forme du taux`)
};

const pt_svchip_rate_shaping = /** @type {(inputs: Svchip_Rate_ShapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelagem de taxa`)
};

const zh_svchip_rate_shaping = /** @type {(inputs: Svchip_Rate_ShapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`速率调整`)
};

const tr_svchip_rate_shaping = /** @type {(inputs: Svchip_Rate_ShapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oran şekillendirme`)
};

const ru_svchip_rate_shaping = /** @type {(inputs: Svchip_Rate_ShapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Формирование ставок`)
};

const pl_svchip_rate_shaping = /** @type {(inputs: Svchip_Rate_ShapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kształtowanie stawek`)
};

/**
* | output |
* | --- |
* | "Rate shaping" |
*
* @param {Svchip_Rate_ShapingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_rate_shaping = /** @type {((inputs?: Svchip_Rate_ShapingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Rate_ShapingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_rate_shaping(inputs)
	if (locale === "bn") return bn_svchip_rate_shaping(inputs)
	if (locale === "de") return de_svchip_rate_shaping(inputs)
	if (locale === "es") return es_svchip_rate_shaping(inputs)
	if (locale === "fr") return fr_svchip_rate_shaping(inputs)
	if (locale === "pt") return pt_svchip_rate_shaping(inputs)
	if (locale === "zh") return zh_svchip_rate_shaping(inputs)
	if (locale === "tr") return tr_svchip_rate_shaping(inputs)
	if (locale === "ru") return ru_svchip_rate_shaping(inputs)
	if (locale === "pl") return pl_svchip_rate_shaping(inputs)
	return en_svchip_rate_shaping(inputs)
});